<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('homework.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('homework.pageTitle'),
            href: '/homeworks'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <staff-homework-create v-if="isStaff" />
    <teacher-homework v-if="isTeacher" />
  </div>
</template>
<script>
import StaffHomeworkCreate from './staff/create'
import TeacherHomework from './teacher/create'

export default {
  name: 'homeworkCreate',
  components: {
    StaffHomeworkCreate,
    TeacherHomework
  },
  data() {
    return {}
  },
  computed: {
    isStaff() {
      return this.$store.getters.isStaffLogin
    },
    isTeacher() {
      return this.$store.getters.isTeacherLogin
    }
  }
}
</script>
